export { default } from './ImpersonationBar';
